var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Project from './Project.vue';
import ProjectMap from '../shared/ProjectMap.vue';
import Loader from '../shared/Loader.vue';
import ProjectDetails from './ProjectDetails.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Choices from 'choices.js';
import { scrollToElement } from '../../../utils/scroll-to';
const service = namespace('Service');
var FilterType;
(function (FilterType) {
    FilterType[FilterType["NONE"] = 0] = "NONE";
    FilterType[FilterType["SECTOR"] = 1] = "SECTOR";
    FilterType[FilterType["LOCATION"] = 2] = "LOCATION";
    FilterType[FilterType["PARTICIPATION"] = 3] = "PARTICIPATION";
    FilterType[FilterType["NAME"] = 4] = "NAME";
})(FilterType || (FilterType = {}));
let ProjectList = class ProjectList extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.data = [];
        this.filteredSectors = [];
        this.activeProjectId = 0;
        this.activeProject = {};
        this.activeFilterType = FilterType.NONE;
        this.activeSectorId = 0;
        this.activeLocationId = 0;
        this.activeParticipationId = 0;
        this.activePartnershipNameId = 0;
        this.mapIsActive = false;
        this.isMobile = false;
        this.projectDetailClass = '';
        this.filterBySelect = null;
        this.sectorFilterSelect = null;
        this.locationFilterSelect = null;
        this.participationFilterSelect = null;
        this.partnershipNameFilterSelect = null;
        this.selectProps = {
            searchEnabled: false,
            shouldSort: false,
            placeholder: true,
            placeholderValue: '',
            itemSelectText: ''
        };
        this.partnershipNames = [
            { id: 1, title: "A-E", regex: /^[a-eA-E]/ },
            { id: 2, title: "F-J", regex: /^[f-jF-J]/ },
            { id: 3, title: "K-O", regex: /^[k-oK-O]/ },
            { id: 4, title: "P-T", regex: /^[p-tP-T]/ },
            { id: 5, title: "U-Z", regex: /^[u-zU-Z]/ },
        ];
    }
    created() {
        if (Vue.$cookies.get('mapIsActive')) {
            this.mapIsActive = Vue.$cookies.get('mapIsActive') === 'true';
        }
        this.isMobile = window.innerWidth <= 1279;
        this.getProjectBrowserData({ showOnHomepage: null, showOnPartnershipMap: true, siteId: window.cibbic.siteId, transform: 'relatedProjects' });
    }
    mounted() {
        window.addEventListener('resize', (evt) => {
            this.isMobile = window.innerWidth <= 1279;
        });
        if (this.activeSector) {
            this.activeSectorId = this.activeSector;
        }
        this.filterBySelect = new Choices('#filterBy', Object.assign(Object.assign({}, this.selectProps), {
            choices: [
                { value: FilterType.NONE, label: this.labels.choose, selected: true },
                { value: FilterType.SECTOR, label: this.labels.sector },
                { value: FilterType.LOCATION, label: this.labels.location },
                { value: FilterType.PARTICIPATION, label: this.labels.participation },
                //{value: FilterType.NAME, label: this.labels.name},
            ],
            'labelId': 'filterByLabel'
        }));
        this.sectorFilterSelect = new Choices('#sectorFilter', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'sectorFilterLabel' }));
        this.locationFilterSelect = new Choices('#locationFilter', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'locationFilterLabel' }));
        this.participationFilterSelect = new Choices('#participationFilter', Object.assign(Object.assign({}, this.selectProps), { 'labelId': 'participationFilterLabel' }));
        // this.partnershipNameFilterSelect = new Choices('#partnershipNameFilter', this.selectProps);
    }
    switchToMap(value) {
        this.mapIsActive = value;
        Vue.$cookies.set('mapIsActive', value.toString());
    }
    onFilterTypeChange(filterType) {
        this.activeFilterType = filterType;
        this.resetFilters();
        this.resetDropdowns();
        this.scrollToProjects();
        this.filterData();
        this.filterActiveProject();
    }
    onSectorChange(_id) {
        this.onDropdownChange("activeSectorId", _id);
    }
    onLocationChange(_id) {
        this.onDropdownChange("activeLocationId", _id);
    }
    onParticipationChange(_id) {
        this.onDropdownChange("activeParticipationId", _id);
    }
    onPartnershipNameChange(_id) {
        this.onDropdownChange("activePartnershipNameId", _id);
    }
    onDropdownChange(property, _id) {
        this[property] = _id;
        this.scrollToProjects();
        this.filterData();
        this.filterActiveProject();
    }
    resetFilters() {
        this.activeSectorId = 0;
        this.activeLocationId = 0;
        this.activeParticipationId = 0;
        this.activePartnershipNameId = 0;
    }
    resetDropdowns() {
        var _a, _b, _c, _d;
        (_a = this.sectorFilterSelect) === null || _a === void 0 ? void 0 : _a.setChoiceByValue(this.activeSectorId);
        (_b = this.locationFilterSelect) === null || _b === void 0 ? void 0 : _b.setChoiceByValue(this.activeLocationId);
        (_c = this.participationFilterSelect) === null || _c === void 0 ? void 0 : _c.setChoiceByValue(this.activeParticipationId);
        (_d = this.partnershipNameFilterSelect) === null || _d === void 0 ? void 0 : _d.setChoiceByValue(this.activePartnershipNameId);
    }
    scrollToProjects() {
        const projectList = this.$refs.projectlist;
        const padding = 50;
        if (window.scrollY < (projectList.offsetTop - padding)) {
            scrollToElement(this.$refs.projectlist, 600, padding);
        }
    }
    filterData() {
        let projects = this.projects;
        // Filter by sectors
        if (this.activeSectorId > 0) {
            projects = projects.filter((project) => {
                return project.sector.some((sector) => {
                    return sector.id === this.activeSectorId;
                });
            });
        }
        // Filter by locations
        if (this.activeLocationId > 0) {
            projects = projects.filter((project) => {
                return project.locationCategories.some((location) => {
                    return location.id === this.activeLocationId;
                });
            });
        }
        // Filter by participations
        if (this.activeParticipationId > 0) {
            projects = projects.filter((project) => {
                return project.participationCategories.some((participation) => {
                    return participation.id === this.activeParticipationId;
                });
            });
        }
        // Filter by partnership names
        if (this.activePartnershipNameId > 0) {
            const nameRegex = this.partnershipNames.find(p => p.id === this.activePartnershipNameId).regex;
            projects = projects.filter((project) => {
                return nameRegex.test(project.title);
            });
        }
        this.data = this.sortProjects(projects);
    }
    filterActiveProject() {
        if (this.activeProject && !this.data.some((project) => {
            var _a;
            return ((_a = this.activeProject) === null || _a === void 0 ? void 0 : _a.id) === project.id;
        })) {
            this.removeProject();
        }
    }
    onMapClick(_id) {
        if (_id === this.activeProjectId)
            return;
        this.activeProjectId = _id;
        this.projectDetailClass = '';
        setTimeout(() => {
            this.activeProject = this.data.find((project) => {
                return project.id === _id;
            });
            this.projectDetailClass = 'show';
        }, 150);
    }
    onMapClickWithFocus(_id) {
        if (_id === this.activeProjectId)
            return;
        this.activeProjectId = _id;
        this.projectDetailClass = '';
        setTimeout(() => {
            this.activeProject = this.data.find((project) => {
                return project.id === _id;
            });
            this.projectDetailClass = 'show';
        }, 150);
        setTimeout(() => {
            const projectDetails = this.$refs.projectDetailsComponent;
            projectDetails.$refs.closeButton.focus();
        }, 200);
    }
    removeProject() {
        setTimeout(() => {
            this.activeProject = {};
        }, 300);
        this.projectDetailClass = '';
        this.activeProjectId = 0;
    }
    removeProjectWithFocus(_projectId) {
        setTimeout(() => {
            this.activeProject = {};
        }, 300);
        this.projectDetailClass = '';
        this.activeProjectId = 0;
        const activeProjectTrigger = document.querySelector(`[data-projectId="${_projectId}"]`);
        activeProjectTrigger.focus();
    }
    sortProjects(projects) {
        return [...projects].sort((a, b) => a.title.localeCompare(b.title));
    }
    fillSectorsDropDown() {
        var _a;
        (_a = this.sectorFilterSelect) === null || _a === void 0 ? void 0 : _a.setChoices(this.getDropDownValues(this.filteredSectors, this.activeSectorId, this.labels.all_sectors), 'value', 'label', true);
    }
    fillLocationsDropDown() {
        var _a;
        (_a = this.locationFilterSelect) === null || _a === void 0 ? void 0 : _a.setChoices(this.getDropDownValues(this.locations, 0, this.labels.all_locations), 'value', 'label', true);
    }
    fillParticipationsDropDown() {
        var _a;
        (_a = this.participationFilterSelect) === null || _a === void 0 ? void 0 : _a.setChoices(this.getDropDownValues(this.participations, 0, this.labels.all_participations), 'value', 'label', true);
    }
    fillPartnershipNamesDropDown() {
        var _a;
        (_a = this.partnershipNameFilterSelect) === null || _a === void 0 ? void 0 : _a.setChoices(this.getDropDownValues(this.partnershipNames, 0, this.labels.all_partnership_names), 'value', 'label', true);
    }
    getDropDownValues(values, activeValueId, label) {
        let tmp = values.map((i) => {
            return { value: i.id, label: i.title, selected: this.activeSectorId == i.id };
        });
        tmp.unshift({ value: 0, label: label, selected: this.activeSectorId === 0 });
        return tmp;
    }
    onDataChanged() {
        this.data = this.sortProjects(this.projects);
        if (this.activeSector) {
            this.onSectorChange(this.activeSector);
        }
        this.loading = false;
    }
    onSectorsChanged() {
        const projectSectorIds = this.projects.flatMap(project => {
            return project.sector.flatMap(projectSector => {
                return projectSector.id;
            });
        });
        this.filteredSectors = this.sectors.filter(sector => {
            return projectSectorIds.includes(sector.id);
        });
        this.data.forEach(project => {
            project.sector.forEach(sector => {
                const exist = this.sectors.find((i) => {
                    return i.id === sector.id;
                });
                if (!exist) {
                    this.sectors.push(sector);
                }
            });
        });
        this.fillSectorsDropDown();
        this.fillLocationsDropDown();
        this.fillParticipationsDropDown();
        this.fillPartnershipNamesDropDown();
    }
};
__decorate([
    Prop({ type: Object })
], ProjectList.prototype, "labels", void 0);
__decorate([
    Prop()
], ProjectList.prototype, "activeSector", void 0);
__decorate([
    service.State
], ProjectList.prototype, "projects", void 0);
__decorate([
    service.State
], ProjectList.prototype, "sectors", void 0);
__decorate([
    service.State
], ProjectList.prototype, "locations", void 0);
__decorate([
    service.State
], ProjectList.prototype, "participations", void 0);
__decorate([
    service.Action
], ProjectList.prototype, "getProjectBrowserData", void 0);
__decorate([
    Watch('projects')
], ProjectList.prototype, "onDataChanged", null);
__decorate([
    Watch('sectors')
], ProjectList.prototype, "onSectorsChanged", null);
ProjectList = __decorate([
    Component({
        components: {
            Project,
            ProjectMap,
            ProjectDetails,
            Loader
        }
    })
], ProjectList);
export default ProjectList;
